export const SITE_URL = (import.meta.env.VITE_SITE_URL || 'https://cloudfla-tools.com').replace(/\/+$/, '');

const sharedKeywords = {
  'zh-CN': [
    'Cloudflare工具',
    'Cloudflare中文工具',
    'Cloudflare中文面板',
    'Cloudflare管理平台',
    'Cloudflare DNS管理',
    'Cloudflare批量DNS',
    'Cloudflare SSL配置',
    'Cloudflare安全规则',
    'Cloudflare国家屏蔽',
    'Cloudflare WAF',
    'Cloudflare Workers',
    'Cloudflare Pages',
    'Cloudflare API',
  ],
  'en-US': [
    'Cloudflare tools',
    'Cloudflare management platform',
    'Cloudflare DNS management',
    'Cloudflare SSL configuration',
    'Cloudflare security rules',
    'Cloudflare WAF',
    'Cloudflare Workers',
    'Cloudflare Pages',
    'Cloudflare API',
  ],
};

function joinKeywords(keywords) {
  return keywords.join(', ');
}

export const seoContent = {
  'zh-CN': {
    siteName: 'Cloudflare Tools',
    defaultTitle: 'Cloudflare Tools | Cloudflare 中文管理工具平台',
    defaultDescription:
      'Cloudflare Tools 是面向中文用户的 Cloudflare 管理工具与 API 平台，支持 DNS 批量管理、SSL/TLS 配置、安全规则、国家访问限制、Workers 与 Pages 管理，以及会员 API 自动化。',
    defaultKeywords: joinKeywords(sharedKeywords['zh-CN']),
    organizationDescription:
      '面向中文用户的 Cloudflare 运维工具站与 API 自动化平台，覆盖 DNS、SSL、安全规则、Workers、Pages 与会员 API。',
    pages: {
      Home: {
        canonicalPath: '/',
        title: 'Cloudflare 中文管理工具平台 | DNS、SSL、WAF、Workers 批量操作',
        description:
          '一站式 Cloudflare 中文工具平台，支持 Cloudflare DNS 管理、SSL/TLS 设置、安全规则、国家屏蔽、Workers 绑定、Pages 部署和会员 API 自动化。',
        keywords: joinKeywords([
          ...sharedKeywords['zh-CN'],
          'Cloudflare批量管理',
          'Cloudflare运维工具',
          'Cloudflare中文API',
          'Cloudflare Pages部署工具',
        ]),
      },
      Pricing: {
        canonicalPath: '/pricing',
        title: 'Cloudflare 工具套餐价格与 API 会员开通 | Cloudflare Tools',
        description:
          '查看 Cloudflare Tools 的免费网页控制台、VIP Yearly 和 VIP Lifetime 套餐。需要 Cloudflare API 自动化、批量管理或部署协助时，可通过 Telegram 人工开通。',
        keywords: joinKeywords([
          'Cloudflare套餐价格',
          'Cloudflare会员API',
          'Cloudflare自动化服务',
          ...sharedKeywords['zh-CN'],
        ]),
      },
      Docs: {
        canonicalPath: '/docs',
        title: 'Cloudflare API 文档与示例 | DNS、SSL、安全规则、Workers',
        description:
          'Cloudflare Tools 在线 API 文档覆盖 Zones、DNS、SSL/TLS、安全规则、Workers 与 Pages，附带中文说明以及 Python、PHP 调用示例。',
        keywords: joinKeywords([
          'Cloudflare API文档',
          'Cloudflare DNS API',
          'Cloudflare SSL API',
          'Cloudflare安全规则API',
          'Cloudflare Workers API',
          ...sharedKeywords['zh-CN'],
        ]),
      },
      Geo: {
        canonicalPath: '/geo',
        title: 'Cloudflare 工具 GEO 说明 | 面向中文搜索与 AI 摘要的产品定位',
        description:
          '了解 Cloudflare Tools 的产品定位、使用边界与适用场景，帮助搜索引擎和 AI 摘要系统更准确理解这是一个面向中文用户的 Cloudflare 管理与自动化平台。',
        keywords: joinKeywords([
          'Cloudflare GEO优化',
          'Cloudflare中文说明',
          'Cloudflare AI摘要',
          ...sharedKeywords['zh-CN'],
        ]),
      },
      Member: {
        canonicalPath: '/member',
        title: 'Cloudflare 会员中心与 API Key 管理 | Cloudflare Tools',
        description:
          '在 Cloudflare Tools 会员中心创建账号、登录、管理 API Key，并为 VIP 会员加密保存 Cloudflare Token，用于后端脚本和自动化调用。',
        keywords: joinKeywords([
          'Cloudflare会员中心',
          'Cloudflare API Key',
          'Cloudflare Token加密保存',
          ...sharedKeywords['zh-CN'],
        ]),
      },
      Dashboard: {
        canonicalPath: '/console',
        title: 'Cloudflare 控制台 | Cloudflare Tools',
        description: '进入 Cloudflare Tools 控制台，集中处理域名、DNS、SSL、安全规则和 Workers 操作。',
        keywords: joinKeywords(sharedKeywords['zh-CN']),
        robots: 'noindex, nofollow, noarchive',
      },
      Config: {
        canonicalPath: '/console/config',
        title: 'Cloudflare 凭证配置 | Cloudflare Tools',
        description: '配置 Cloudflare 账号、邮箱和 API Token，以便在网页控制台中安全使用 Cloudflare Tools。',
        keywords: joinKeywords(sharedKeywords['zh-CN']),
        robots: 'noindex, nofollow, noarchive',
      },
      DNS: {
        canonicalPath: '/console/dns',
        title: 'Cloudflare DNS 管理控制台 | Cloudflare Tools',
        description: '通过网页控制台集中管理 Cloudflare DNS 记录，包括查询、新增、修改和删除。',
        keywords: joinKeywords(['Cloudflare DNS控制台', 'Cloudflare DNS记录管理', ...sharedKeywords['zh-CN']]),
        robots: 'noindex, nofollow, noarchive',
      },
      DNSBatch: {
        canonicalPath: '/console/dns-batch',
        title: 'Cloudflare 批量 DNS 管理 | Cloudflare Tools',
        description: '批量新增、修改和同步 Cloudflare DNS 记录，适合多域名项目和批处理场景。',
        keywords: joinKeywords(['Cloudflare批量DNS', '批量域名解析', ...sharedKeywords['zh-CN']]),
        robots: 'noindex, nofollow, noarchive',
      },
      SSL: {
        canonicalPath: '/console/ssl',
        title: 'Cloudflare SSL/TLS 配置 | Cloudflare Tools',
        description: '快速查看和修改 Cloudflare SSL/TLS 模式、证书策略与相关安全设置。',
        keywords: joinKeywords(['Cloudflare SSL配置', 'Cloudflare TLS设置', ...sharedKeywords['zh-CN']]),
        robots: 'noindex, nofollow, noarchive',
      },
      SSLBatch: {
        canonicalPath: '/console/ssl-batch',
        title: 'Cloudflare 批量 SSL/TLS 设置 | Cloudflare Tools',
        description: '针对多个域名批量下发 Cloudflare SSL/TLS 配置，提高站群和批量运维效率。',
        keywords: joinKeywords(['Cloudflare批量SSL', 'Cloudflare批量TLS', ...sharedKeywords['zh-CN']]),
        robots: 'noindex, nofollow, noarchive',
      },
      Security: {
        canonicalPath: '/console/security',
        title: 'Cloudflare 安全规则与国家访问控制 | Cloudflare Tools',
        description: '配置 Cloudflare 安全规则、国家访问控制、WAF 与批量安全策略，适合站点防护和地理访问限制。',
        keywords: joinKeywords(['Cloudflare安全规则', 'Cloudflare国家屏蔽', 'Cloudflare WAF规则', ...sharedKeywords['zh-CN']]),
        robots: 'noindex, nofollow, noarchive',
      },
      DomainBatch: {
        canonicalPath: '/console/domain-batch',
        title: 'Cloudflare 批量新增域名 | Cloudflare Tools',
        description: '批量将域名接入 Cloudflare 账号，适用于站群部署、代理业务和批量运维。',
        keywords: joinKeywords(['Cloudflare批量添加域名', 'Cloudflare站群管理', ...sharedKeywords['zh-CN']]),
        robots: 'noindex, nofollow, noarchive',
      },
      WorkersBatch: {
        canonicalPath: '/console/workers-batch',
        title: 'Cloudflare Workers 批量绑定 | Cloudflare Tools',
        description: '批量绑定 Cloudflare Workers 与路由，适用于多域名、多路径或批量脚本发布场景。',
        keywords: joinKeywords(['Cloudflare Workers绑定', 'Cloudflare批量Workers', ...sharedKeywords['zh-CN']]),
        robots: 'noindex, nofollow, noarchive',
      },
    },
  },
  'en-US': {
    siteName: 'Cloudflare Tools',
    defaultTitle: 'Cloudflare Tools | Cloudflare management platform',
    defaultDescription:
      'Cloudflare Tools is a Cloudflare management and API automation platform with DNS management, SSL/TLS setup, security rules, country access control, Workers, Pages, and member API access.',
    defaultKeywords: joinKeywords(sharedKeywords['en-US']),
    organizationDescription:
      'Cloudflare operations toolkit and API automation platform for public web usage, member APIs, DNS, SSL, security, Workers, and Pages.',
    pages: {
      Home: {
        canonicalPath: '/',
        title: 'Cloudflare management platform | DNS, SSL, WAF, Workers, and batch operations',
        description:
          'Use Cloudflare Tools to manage Cloudflare DNS, SSL/TLS, security rules, country access control, Workers bindings, Pages deployment, and member API automation from one place.',
        keywords: joinKeywords([
          ...sharedKeywords['en-US'],
          'Cloudflare batch management',
          'Cloudflare operations toolkit',
          'Cloudflare Pages deployment tools',
        ]),
      },
      Pricing: {
        canonicalPath: '/pricing',
        title: 'Cloudflare pricing and API membership | Cloudflare Tools',
        description:
          'Compare the public web console, VIP Yearly, and VIP Lifetime plans for Cloudflare Tools. Contact Telegram for API automation, batch operations, or deployment assistance.',
        keywords: joinKeywords(['Cloudflare pricing', 'Cloudflare API membership', ...sharedKeywords['en-US']]),
      },
      Docs: {
        canonicalPath: '/docs',
        title: 'Cloudflare API docs and examples | DNS, SSL, security, Workers',
        description:
          'Read the Cloudflare Tools API reference for Zones, DNS, SSL/TLS, security rules, Workers, and Pages with Python and PHP examples.',
        keywords: joinKeywords(['Cloudflare API docs', 'Cloudflare DNS API', 'Cloudflare security API', ...sharedKeywords['en-US']]),
      },
      Geo: {
        canonicalPath: '/geo',
        title: 'Cloudflare GEO overview | Product positioning for search and AI summaries',
        description:
          'Understand the positioning, boundaries, and use cases of Cloudflare Tools so search engines and AI summarizers can better understand the platform.',
        keywords: joinKeywords(['Cloudflare GEO', 'Cloudflare overview', ...sharedKeywords['en-US']]),
      },
      Member: {
        canonicalPath: '/member',
        title: 'Cloudflare member center and API keys | Cloudflare Tools',
        description:
          'Create an account, sign in, manage API keys, and store an encrypted Cloudflare token for backend scripts and automation.',
        keywords: joinKeywords(['Cloudflare member center', 'Cloudflare API key', ...sharedKeywords['en-US']]),
      },
      Dashboard: {
        canonicalPath: '/console',
        title: 'Cloudflare console | Cloudflare Tools',
        description: 'Use the Cloudflare Tools console for domains, DNS, SSL, security, and Workers workflows.',
        keywords: joinKeywords(sharedKeywords['en-US']),
        robots: 'noindex, nofollow, noarchive',
      },
      Config: {
        canonicalPath: '/console/config',
        title: 'Cloudflare credentials setup | Cloudflare Tools',
        description: 'Set up your Cloudflare account, email, and API token for secure browser-based workflows.',
        keywords: joinKeywords(sharedKeywords['en-US']),
        robots: 'noindex, nofollow, noarchive',
      },
      DNS: {
        canonicalPath: '/console/dns',
        title: 'Cloudflare DNS console | Cloudflare Tools',
        description: 'Create, review, update, and delete Cloudflare DNS records from the browser.',
        keywords: joinKeywords(['Cloudflare DNS console', 'Cloudflare DNS records', ...sharedKeywords['en-US']]),
        robots: 'noindex, nofollow, noarchive',
      },
      DNSBatch: {
        canonicalPath: '/console/dns-batch',
        title: 'Cloudflare batch DNS management | Cloudflare Tools',
        description: 'Apply DNS changes across multiple domains with batch operations.',
        keywords: joinKeywords(['Cloudflare batch DNS', ...sharedKeywords['en-US']]),
        robots: 'noindex, nofollow, noarchive',
      },
      SSL: {
        canonicalPath: '/console/ssl',
        title: 'Cloudflare SSL/TLS settings | Cloudflare Tools',
        description: 'Review and update Cloudflare SSL/TLS modes, policies, and related settings.',
        keywords: joinKeywords(['Cloudflare SSL settings', ...sharedKeywords['en-US']]),
        robots: 'noindex, nofollow, noarchive',
      },
      SSLBatch: {
        canonicalPath: '/console/ssl-batch',
        title: 'Cloudflare batch SSL/TLS settings | Cloudflare Tools',
        description: 'Roll out SSL/TLS settings to multiple domains from one workflow.',
        keywords: joinKeywords(['Cloudflare batch SSL', ...sharedKeywords['en-US']]),
        robots: 'noindex, nofollow, noarchive',
      },
      Security: {
        canonicalPath: '/console/security',
        title: 'Cloudflare security rules and country controls | Cloudflare Tools',
        description: 'Configure security rules, WAF, and country access controls for Cloudflare zones.',
        keywords: joinKeywords(['Cloudflare security rules', 'Cloudflare country access control', ...sharedKeywords['en-US']]),
        robots: 'noindex, nofollow, noarchive',
      },
      DomainBatch: {
        canonicalPath: '/console/domain-batch',
        title: 'Cloudflare batch domains | Cloudflare Tools',
        description: 'Add and manage multiple domains in Cloudflare accounts with a batch workflow.',
        keywords: joinKeywords(['Cloudflare batch domains', ...sharedKeywords['en-US']]),
        robots: 'noindex, nofollow, noarchive',
      },
      WorkersBatch: {
        canonicalPath: '/console/workers-batch',
        title: 'Cloudflare Workers batch binding | Cloudflare Tools',
        description: 'Bind Workers routes across multiple domains and paths in one place.',
        keywords: joinKeywords(['Cloudflare Workers binding', ...sharedKeywords['en-US']]),
        robots: 'noindex, nofollow, noarchive',
      },
    },
  },
};
